export default {
    coreSkill: null,
}
